import { Component, OnInit } from '@angular/core';
import { CommonRequestResponseService } from 'app/services/common-request-response.service';
import { NotificationService } from 'app/services/notification.service';

@Component({
  selector: 'app-my-cap',
  templateUrl: './my-cap.component.html',
  styleUrls: ['./my-cap.component.scss']
})
export class MyCapComponent implements OnInit {

  currentPageId: any;
  howItWorksData: any;
  localData: any;

  constructor(
    private _commonRequestResponseService: CommonRequestResponseService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.localData = JSON.parse(localStorage.getItem('loginUserData'));
    this.getHowItWorksData();
  }

  getHowItWorksData() {
    const inputJson = {
      pageclassid: 2545
    };
    this._commonRequestResponseService.postWithHeader('shared/contentdetails/howItWorks', inputJson)
      .subscribe(
        (howItworksJson: any) => {
          this.howItWorksData = howItworksJson;
        },
        () => {
          this.notificationService.show('info', 'Error while getting how it works data');
        });
  }
  getMyCapAccess() {

    const data = {
      userId: this.localData.userId,
      partnerId: this.localData.partnerId,
      email: this.localData.email
    };
    this._commonRequestResponseService.postWithHeader('student/GenerateMyCapURL', data)
      .subscribe(
        (myCap: any) => {
          if (myCap['url']) {
            window.open(myCap['url']);
          }
        },
        () => {
          this.notificationService.show('error', 'Error while fetching my cap data');
        });
  }
}
